export default "__VITE_ASSET__D56UYz_2__"